import { Table } from "@mantine/core";
import { useHeldEmailActionable } from "../../../hooks/admin/useHeldEmailSelection";
import { HeldEmailListItem } from "../../../services/admin/systemEmails.service";
import { HeldEmailSelectionCheckbox } from "./HeldEmailSelectionCheckbox";
import { HeldEmailSelectionModel } from "./heldEmailSelection";

interface Props {
  email: HeldEmailListItem;
  canRelease: boolean;
  selection: HeldEmailSelectionModel;
}

export function HeldEmailQueueSelectionCell({
  email,
  canRelease,
  selection,
}: Props) {
  const actionable = useHeldEmailActionable(email, canRelease);
  return (
    <Table.Td>
      <HeldEmailSelectionCheckbox
        checked={selection.selectedIds.has(email.id)}
        disabled={!actionable}
        id={email.id}
        label={email.subject}
        selection={selection}
      />
    </Table.Td>
  );
}
